/**
 * @generated SignedSource<<0179f2a845b06154b7d2a5b4a3374da7>>
 * @relayHash 2371ae2e488d72c63739ca7ae35f863b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 220f739fdf1efc8f4762c55944793d7e795a7103470dc44d706b2e0e462f717d

import { ConcreteRequest, Query } from 'relay-runtime';
export type PresentationScreenContentWrapperLegacyUrlQuery$variables = {
  id: string;
};
export type PresentationScreenContentWrapperLegacyUrlQuery$data = {
  readonly node: {
    readonly __typename: "Presentation";
    readonly prettyUrl: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type PresentationScreenContentWrapperLegacyUrlQuery = {
  response: PresentationScreenContentWrapperLegacyUrlQuery$data;
  variables: PresentationScreenContentWrapperLegacyUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PresentationScreenContentWrapperLegacyUrlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PresentationScreenContentWrapperLegacyUrlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "220f739fdf1efc8f4762c55944793d7e795a7103470dc44d706b2e0e462f717d",
    "metadata": {},
    "name": "PresentationScreenContentWrapperLegacyUrlQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f238a3ddf2e33e3bc92246fc4afdca3c";

export default node;
